import React, { useState, useRef, useEffect } from "react";

import "./PreviewFileDialog.css"
import { FileType } from "../choose-file-dialog/ChooseFileDialog";
import { FormatBytes } from "../../helpers/file-helper/FileSizeHelper";
import { useTranslation } from 'react-i18next';
import { showErrorToastr } from "../../helpers/toastr-helper/ToastrHelper";
import { Dropdown, DropdownMenu } from "reactstrap";
import { isImageTypeSupported } from "../../helpers/img-helpers/ImageSupportHelper";

interface previewFileDialogProps {
    file: File | undefined,
    type: FileType | undefined,
    sendWithDragAndDrop?: boolean | undefined,
    resetSendWithDragAndDrop?(): void,
    onFileSend(): void,
    onFileClear(): void
}

export default function PreviewFileDialog(props: previewFileDialogProps) {
    const { t } = useTranslation();
    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
    const imageRef = useRef<HTMLImageElement | null>(null);

    useEffect(() => {
        if (props.file != null) {
            setIsMenuVisible(true);
        }
    }, [props.file])

    useEffect(() => {
        if (isMenuVisible == false) {
            if (props.resetSendWithDragAndDrop != undefined) {
                props.resetSendWithDragAndDrop()
            }
        }
    }, [isMenuVisible])

    const _mapFileDialog = () => {
        if (props.file === undefined) return;
        return (
            <React.Fragment>
                {_mapFileName()}
                <i>{FormatBytes(props.file.size, 3)}</i>
            </React.Fragment>
        )
    }

    const _mapImageDialog = () => {
        if (props.file === undefined) return;
        if (!isImageTypeSupported(props.file.type)) {
            setIsMenuVisible(false);
            showErrorToastr(t('common.fileSendLikeImageError'));
            return;
        }
        const reader = new FileReader();
        reader.onload = function (e) {
            if (e.target?.result && typeof e.target.result === "string") {
                imageRef?.current?.setAttribute("src", e.target.result)
            }

        }
        reader.readAsDataURL(props?.file);

        return (
            <React.Fragment>
                <div className="previewFileDialog__image">
                    <img ref={imageRef}></img>
                    {_mapFileName()}
                    <i>{FormatBytes(props.file.size, 3)}</i>
                </div>
            </React.Fragment>
        )
    }

    const _mapFileName = () => {
        let fileName = props.file?.name;
        if (fileName && fileName.length > 35) {
            fileName = fileName.substring(0, 27) + "..." + fileName.substring(fileName.length - 7, fileName.length);
        }
        return (
            <React.Fragment>
                <div title={props.file?.name} className="previewFileDialog__file-name">{fileName}</div>
            </React.Fragment>
        )
    }

    const sendFile = () => {
        setIsMenuVisible(false);
        props.onFileSend()
    };

    const cancelFile = () => {
        setIsMenuVisible(false);
        props.onFileClear?.(); 
    }
  
    return (
        <React.Fragment>
            <Dropdown className="preview-file-dialog__container">
                {isMenuVisible && 
                    <DropdownMenu className={"preview-file-dialog__menu " + (props.type === FileType.File ? "file" : "image")}>
                        {props.type === FileType.File && _mapFileDialog()}
                        {props.type === FileType.Image && _mapImageDialog()}
                        <div className="previewFileDialog__footer">
                            <button 
                                data-testid="preview-file-cancel"
                                className="btn-small preview-file-dialog__cancel_button"
                                tabIndex={0}
                                onClick={cancelFile}
                                onKeyUp={(e) => e.key === "Enter" && setIsMenuVisible(false)}
                            >
                                {t('common.cancel')}
                            </button>
                            <button 
                                data-testid="preview-file-send"
                                className="btn-small"
                                tabIndex={0}
                                onClick={sendFile}
                                onKeyUp={(e) => e.key === "Enter" && sendFile()}
                            >
                                {t('common.send')}
                            </button>
                        </div>
                    </DropdownMenu>
                }
            </Dropdown>
        </React.Fragment>
    )
}